
import { useState } from 'react';
import { mockDatabases } from '../data/mockData';

export interface Database {
  id: string;
  name: string;
  type: 'postgresql' | 'mysql' | 'mssql' | 'oracle' | 'mongodb';
  host: string;
  port: string;
  username: string;
  password: string;
  database: string;
  status: 'connected' | 'disconnected' | 'pending';
}

export const useDatabasesData = () => {
  const [databases, setDatabases] = useState<Database[]>(mockDatabases as Database[]);

  const addDatabase = (database: Database) => {
    setDatabases([...databases, database]);
  };

  const updateDatabase = (updatedDatabase: Database) => {
    setDatabases(databases.map(db => 
      db.id === updatedDatabase.id ? updatedDatabase : db
    ));
  };

  const removeDatabase = (id: string) => {
    setDatabases(databases.filter(db => db.id !== id));
  };

  return {
    databases,
    addDatabase,
    updateDatabase,
    removeDatabase
  };
};
